export default __webpack_public_path__ + "static/media/khitaigreatwall.9f0212b7.jpg";